// import Crud from '../views/Facial/Crud'
// import View from '../views/Facial/View'
import Entity from '../views/Facial/Add'

let routes = {
    path: '/cbo',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/facial/add',
            name: 'NewFacial',
            component: Entity,
            meta: {
                pageTitle: 'Cadastrar face',
                breadcrumb: [
                    // {
                    //     text: 'Rostos',
                    //     active: false,
                    //     to: '/facial',
                    // },
                    {
                        text: 'Cadastrar Facial',
                        active: true,
                    }
                ],
            },
        },
        // {
        //     path: '/facial/edit/:id?',
        //     name: 'EditFacial',
        //     component: Entity,
        //     meta: {
        //         pageTitle: 'Edição de cadastro facial',
        //         breadcrumb: [
        //             {
        //                 text: 'Rostos',
        //                 active: false,
        //                 to: '/facial',
        //             },
        //             {
        //                 text: 'Editar',
        //                 active: true,
        //             }
        //         ],
        //     },
        // },
        // {
        //     path: '/facial/view/:id?',
        //     name: 'ViewFacial',
        //     component: View,
        //     meta: {
        //         pageTitle: 'Visualizar cadastro facial',
        //         breadcrumb: [
        //             {
        //                 text: 'Rostos',
        //                 active: false,
        //                 to: '/facial',
        //             },
        //             {
        //                 text: 'Visualizar',
        //                 active: true,
        //             }
        //         ],
        //     },
        // },
        // {
        //     path: '/facial',
        //     name: 'list-facial',
        //     component: Crud,
        //     meta: {
        //         pageTitle: 'Rostos salvos',
        //         breadcrumb: [
        //             {
        //                 text: 'Rostos',
        //                 active: true,
        //             },
        //         ],
        //     },
        // },
    ]
};


export default routes
